import moment from "moment";
import { db } from "@/utilities/firebase";
import _ from "lodash";

export const getVictorianData = () => {
  return new Promise((resolve, reject) => {
    db.collection("covidData")
      .doc("victorianData")
      .get()
      .then(doc => {
        let mappedData = _.flatMap(doc.data(), mapData);

        // dateStamp is currently UNIX timecode. This code block sorts
        // the data by date, so that the graph appears normal
        mappedData.sort((objectA, objectB) => {
          return objectA.dateStamp - objectB.dateStamp;
        });

        // This code block converts the UNIX timecode to a DD/MM format
        mappedData = mappedData.map(dataPoint => {
          dataPoint.dateStamp = moment
            .unix(dataPoint.dateStamp)
            .format("DD/MM");
          return dataPoint;
        });

        const victorianStatistics = (graphLabel, graphColor, graphDataKey) => {
          return {
            label: graphLabel,
            backgroundColor: graphColor,
            data: mappedData.map(dataPoint => {
              return dataPoint[graphDataKey];
            })
          };
        };

        let dateRange = mappedData.map(dataPoint => {
          return dataPoint.dateStamp;
        });

        let activeCaseData = victorianStatistics(
          "Victorian Active Infections",
          "rgba(0, 1, 125, 0.8)",
          "activeCases"
        );

        let newCaseData = victorianStatistics(
          "Victorian New Infections",
          "rgba(134, 179, 205, 0.7)",
          "newConfirmed"
        );

        let totalCaseData = victorianStatistics(
          "Victorian Total Cases",
          "rgba(25, 85, 121, 0.7)",
          "cumulativeConfirmed"
        );

        let recoveredCaseData = victorianStatistics(
          "Victorian Recovered Cases",
          "rgba(124, 234, 156, 0.7)",
          "cumulativeRecovered"
        );

        let newDeathData = victorianStatistics(
          "Victorian New Deaths",
          "rgba(252, 127, 133, 0.7)",
          "newDeaths"
        );

        let totalDeathData = victorianStatistics(
          "Victorian Total Deaths",
          "rgba(206, 45, 53, 0.7)",
          "cumulativeDeaths"
        );

        let dataSets = {
          activeCaseData: activeCaseData,
          newCaseData: newCaseData,
          totalCaseData: totalCaseData,
          recoveredCaseData: recoveredCaseData,
          newDeathData: newDeathData,
          totalDeathData: totalDeathData
        };

        resolve({
          dateRange: dateRange,
          dataSets: dataSets
        });
      })
      .catch(error => {
        reject(error);
      });
  });
};

const mapData = (object, key) => {
  return { dateStamp: key / 1000, ...object };
};
